import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { displayNotification, sendAPIRequest } from "helpers";

const IssueSeverityPriorityModal = ({ isShow, initModal, issueId }) => {
    const { t } = useTranslation();

    const [formValues, setFormValues] = useState({
        severity: "",
        priority: "",
    });

    const severityOptions = [
        { label: "Minor", value: "Minor" },
        { label: "Major", value: "Major" },
        { label: "Blocker", value: "Blocker" },
    ];

    const priorityOptions = [
        { label: "Low", value: "Low" },
        { label: "Medium", value: "Medium" },
        { label: "High", value: "High" },
    ];

    useEffect(() => {
        if (isShow) {
            setFormValues({
                severity: "",
                priority: "",
            });
        }
    }, [isShow]);

    const handleChange = (field, value) => {
        setFormValues(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async () => {
        const { severity, priority } = formValues;
        if (!severity || !priority) {
            alert(t("Please fill in all required fields"));
            return;
        }
        try {
            const ret = await sendAPIRequest(`/api/reported-issues/${issueId}`, "PUT", formValues);
            const res = await ret.json();
            if (res.success) {
                displayNotification("success", res.message);
                initModal();
            } else {
                displayNotification("error", res.message);
            }
        } catch (error) {
            console.error("Update error:", error);
            alert(t("An error occurred"));
        }
    };

    return (
        <Modal show={isShow} onHide={initModal}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Assignment to Level 2")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="severitySelect">
                    <AutoCompleteDropdown
                        label={t("Severity")}
                        multiple={false}
                        options={severityOptions}
                        value={severityOptions.find(opt => opt.value === formValues.severity) || null}
                        onChange={(e, val) => handleChange("severity", val?.value || "")}
                    />
                </Form.Group>

                <Form.Group controlId="prioritySelect" className="mt-3">
                    <AutoCompleteDropdown
                        label={t("Priority")}
                        multiple={false}
                        options={priorityOptions}
                        value={priorityOptions.find(opt => opt.value === formValues.priority) || null}
                        onChange={(e, val) => handleChange("priority", val?.value || "")}
                    />
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn--outline" onClick={initModal}>
                    {t("Cancel")}
                </button>
                <button className="btn btn--primary" onClick={handleSubmit}>
                    {t("Escalate to Level 2")}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default IssueSeverityPriorityModal;
